export default __webpack_public_path__ + "static/gta-f7647130edac06c70f9543666cba54ae.png";